import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Signup2() {
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const info = localStorage.getItem("user");
    const user = JSON.parse(info);
    const newuser = {
      address: { state, country, city, street: address, postalCode },
      ...user,
    };
    const userString = JSON.stringify(newuser);
    localStorage.setItem("user", userString);
    navigate("/signup3");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Welcome Back</h1>
        <form onSubmit={handleLogin}>
          <label>Country</label>
          <input
            type="text"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            placeholder="Enter your country"
            required
          />
          <label>State</label>
          <input
            type="text"
            value={state}
            onChange={(e) => setState(e.target.value)}
            placeholder="Enter your state"
            required
          />

          <label>City</label>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter your city"
            required
          />
          <label>Street address</label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter your Street address"
            required
          />
          <label>Postal code</label>
          <input
            type="text"
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            placeholder="Enter your Postal code"
            required
          />

          <button type="submit">Continue</button>
        </form>
        <p className="signup-text">
          Already have an account? <span onClick={()=>navigate("/login")}>Login</span>
        </p>
      </div>
    </div>
  );
}
